import { render } from "./WCCartDrawerSpecialOrderItem.vue?vue&type=template&id=edba871c&scoped=true"
import script from "./WCCartDrawerSpecialOrderItem.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerSpecialOrderItem.vue?vue&type=script&lang=js"

import "./WCCartDrawerSpecialOrderItem.vue?vue&type=style&index=0&id=edba871c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edba871c"]])

export default __exports__